import { useCallback, useState } from 'react'

export const useMergeState = (initialState = {}) => {
  const [value, setValue] = useState(initialState)

  const mergeState = useCallback(newState => {
    const defaultUpdater = currentValue => ({ ...currentValue, ...newState })
    setValue(typeof newState === 'function' ? newState : defaultUpdater)
  }, [])

  return [value, mergeState]
}
